/**
 * Undo an optimistic chat append after the send failed (OBS-11).
 *
 * ClientChat shows the message immediately under a `temp_…` id and records it in
 * `pendingSends` so the post-send refresh can match it to the server row. If the send
 * throws, both must be removed — otherwise the bubble stays on screen looking sent while
 * the message never reached the coach (the bug this fixes: the catch used to be empty).
 */
export function rollbackOptimisticSend<M extends { id: unknown }, P extends { tempId: string }>(
  messages: M[],
  pendingSends: P[],
  tempId: string,
): { messages: M[]; pendingSends: P[] } {
  return {
    messages: messages.filter((m) => String(m.id) !== tempId),
    pendingSends: pendingSends.filter((p) => p.tempId !== tempId),
  };
}
